<template>
  <div id="menu">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <h2 class="view-title">Configuración</h2>
      </div>
    </div>


    <div class="row mt-3 pb-5">
      <div class="col-xl-4 col-lg-4 col-md-6">
        <div class="cotizarlo-general-wrapper wrapper-padding">
          <div class="card-body p-0">
            <div class="d-flex mb-2 align-items-center">
              <h3 class="m-0 subtitle-section">Ajustes de cotizaciones</h3>
              <span class="ml-2 icon-cot-info" v-tooltip="'En este menú podrás personalizar tus cotizaciones, desde su diseño, hasta la información que se despliega en ella.'"></span>
            </div>
            <nav class="nav flex-column">
              <router-link to="/configuracion/informacion" class="nav-link">
                <img src="@/assets/icons/settings_2.svg" class="mr-3" width="13"> 
                Información de la empresa
              </router-link>
              <router-link to="/configuracion/emails" class="nav-link" v-if="userRole != 'Gratis'">
                <img src="@/assets/icons/settings_4.svg" class="mr-3" width="13"> 
                Correos a clientes
              </router-link>
              <div v-else class="nav-link text-muted">
                <img src="@/assets/icons/settings_4.svg" class="mr-3" width="13"> 
                Correos a clientes <span class="paid-option"><a href="configuracion/pagos">Funcionalidad de paga</a></span>
              </div>
              <router-link to="/configuracion/valores" class="nav-link">
                <img src="@/assets/icons/settings_3.svg" class="mr-3" width="13"> 
                Valores predefinidos
              </router-link>
              <router-link  to="/configuracion/formato" class="nav-link" v-if="userRole != 'Gratis'">
                <img src="@/assets/icons/settings_1.svg" class="mr-3" width="13"> 
                Diseño y formato
              </router-link>
              <div v-else class="nav-link text-muted">
                <img src="@/assets/icons/settings_1.svg" class="mr-3" width="13"> 
                Diseño y formato <span class="paid-option"><a href="configuracion/pagos">Funcionalidad de paga</a></span>
              </div>
              <!-- <router-link to="/configuracion/notificaciones" class="nav-link">
                <img src="@/assets/icons/settings_5.svg" class="mr-3" width="13"> Notificaciones
              </router-link> -->
              <router-link to="/configuracion/remitente" class="nav-link" v-if="userRole != 'Gratis'">
                <img src="@/assets/icons/settings_6.svg" class="mr-3" width="13"> 
                Correo remitente
              </router-link>
              <div v-else class="nav-link text-muted">
                <img src="@/assets/icons/settings_6.svg" class="mr-3" width="13"> 
                Correo remitente <span class="paid-option"><a href="configuracion/pagos">Funcionalidad de paga</a></span>
              </div>
            </nav>
          </div>
        </div>
      </div>
    
      <div class="col-xl-4 col-lg-4 col-md-6 mt-3 mt-sm-3 mt-md-0 mt-lg-0 mt-xl-0">
        <div class="cotizarlo-general-wrapper wrapper-padding">
          <div class="card-body p-0">
            <div class="d-flex mb-2 align-items-center">
              <h3 class="m-0 subtitle-section">Cuenta y facturación</h3>
              <span class="ml-2 icon-cot-info" v-tooltip="'Revisa el estado de tu plan, llena tus datos de facturación y descarga tus recibos de pago.'"></span>
            </div>
            <nav class="nav flex-column">
              <router-link to="/configuracion/pagos" class="nav-link">
                <img src="@/assets/icons/settings_7.svg" class="mr-3" width="13"> 
                Planes y pagos
              </router-link>
              <!-- <router-link to="/configuracion/cuenta" class="nav-link">
                <img src="@/assets/icons/settings_8.svg" class="mr-3" width="13"> Información de la cuenta
              </router-link> -->
              <router-link 
                to="/configuracion/exportar" 
                class="nav-link" >
                <img src="@/assets/icons/settings_9.svg" class="mr-3" width="13"> 
                Exportar cotizaciones
              </router-link>
              
            </nav>
          </div>
        </div>
      </div>
      
      <div class="col-xl-4 col-lg-4 col-md-6 mt-3 mt-sm-3 mt-md-3 mt-lg-0 mt-xl-0" v-if="userRole == 'Dueno'">
        <div class="cotizarlo-general-wrapper wrapper-padding">
          <div class="card-body p-0">
            <div class="d-flex mb-2 align-items-center">
              <h3 class="m-0 subtitle-section">Equipo</h3>
              <span class="ml-2 icon-cot-info" v-tooltip="'Invita y administra los miembros de tu equipo.'"></span>
            </div>
            <nav class="nav flex-column">
              <router-link to="/configuracion/equipo" class="nav-link">
                <img src="@/assets/icons/members.svg" class="mr-3" width="18"> 
                Administrar equipo
              </router-link>
              <!-- <router-link to="/configuracion/agregar" class="nav-link">
                <img src="@/assets/icons/settings_12.svg" class="mr-3" width="13"> 
                Agregar miembros
              </router-link> -->
            </nav>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data from '@/mixins/data'

export default {
  mixins: [data]
}
</script>

<style lang="scss" scoped>
  .nav-link{
    color: #0C203D;
    border-bottom: 0.5px solid #C1C7D0;
    &:last-child{
      border: none;
    }
    &:hover{
      color: #061022;
    }
  }
</style>